import BaseModalStore from '../layout/base-store';

class FollowUsModalStore extends BaseModalStore {
  name = '关注我们弹窗';

  use() {
    super.use();
  }
}

export default FollowUsModalStore;
